import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import routes from 'routes';
import { getAuthLoading, getAuthUser } from 'store/auth/selectors';

const authLoadingFallback = (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '40vh',
      width: '100%',
    }}
  >
    <Spin size="large" />
  </div>
);

export const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const loading = useSelector(getAuthLoading);
  const user = useSelector(getAuthUser);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!loading && !user) {
      navigate(routes.login, { replace: true });
    }
  }, [loading, user, navigate]);

  if (loading) {
    return authLoadingFallback;
  }

  if (user) {
    return <>{children}</>;
  }

  return authLoadingFallback;
};
